import { useFormState } from "react-final-form";
import rffEvaluateFieldCondition from "../../../utils/finalForm/rffEvaluateFieldCondition";

/**
 * A conditional wrapper component for React Final Form fields
 * Supports both simple conditions and complex nested rule groups
 */
const RffConditional = ({
  // Single-rule props
  field,
  operator,
  value,
  // Multi-rule props
  rules,
  // Operator for multiple rules, defaults to "AND"
  operatorForMultiple = "AND",
  // Complete condition object prop
  condition: conditionObj,
  // Testing props
  testing,
  // Children to conditionally render
  children,
}) => {
  const { values } = useFormState();

  // Determine which condition format we're using
  let condition;

  if (conditionObj) {
    // If a full condition object was passed, use it directly
    condition = conditionObj;
  } else if (rules) {
    // If rules were provided, use the multi-rule format
    condition = {
      operator: operatorForMultiple,
      rules: rules,
    };
  } else if (field) {
    // If field was provided, use the single rule format
    condition = {
      operator: operator || "==",
      rules: [
        {
          field,
          operator: operator || "==",
          value,
        },
      ],
    };
  } else {
    // Default case - no condition, render children
    return <>{children}</>;
  }

  // Evaluate the condition against current form values
  const shouldRender = rffEvaluateFieldCondition(condition, values);

  if (!shouldRender) {
    return null;
  }

  return children;
};

/**
 * USAGE EXAMPLE:
  <RffConditional
        field={LMT.isBrokeredLoan}
        value={true}
        // operatorForMultiple={"OR"}
        // rules={[
        //   { field: "citizenshipStatus", operator: "==", value: "US Citizen" },
        //   {
        //     field: "citizenshipStatus",
        //     operator: "==",
        //     value: "Foreign National with SSN",
        //   },
        //   {
        //     field: "citizenshipStatus",
        //     operator: "==",
        //     value: "Foreign National",
        //   },
        // ]}
      >
        <RffGroup title="Broker Contact Info">
          <RffFieldsRenderer fields={brokerFields} />
        </RffGroup>
      </RffConditional>
 */
export default RffConditional;
